var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96894 3.50097C8.14683 3.48989 8.31717 3.57435 8.41603 3.72265L9.19338 4.88868L8.36133 5.44338L8.06191 4.99424L7.47362 6.17082L6.57919 5.72361L7.5528 3.7764C7.6325 3.61698 7.79105 3.51204 7.96894 3.50097ZM9.63868 5.55663L10.1712 6.35539L10.7764 6.05279L11.2236 6.94722L10.2236 7.44722C9.99808 7.55999 9.72386 7.48716 9.58398 7.27735L8.80663 6.11133L9.63868 5.55663ZM2.58398 7.27735L3.41603 6.72265L4.19338 7.88868L3.36133 8.44338L2.58398 7.27735ZM6.42083 8.2764L5.44722 10.2236C5.36751 10.383 5.20897 10.488 5.03108 10.499C4.85319 10.5101 4.68285 10.4257 4.58398 10.2774L3.80663 9.11133L4.63868 8.55663L4.93811 9.00577L5.5264 7.82918L6.42083 8.2764Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6H11V7H8H3V6Z",
    fill: "white"
  })));
};
export default __webpack_public_path__ + "static/media/tree-mean-icon.3cf99d00.svg";
export { SvgComponent as ReactComponent };